import { render, staticRenderFns } from "./api-partners.vue?vue&type=template&id=0339f2e3&"
import script from "./api-partners.vue?vue&type=script&lang=js&"
export * from "./api-partners.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports